export default __webpack_public_path__ + "static/media/blood_donation.3ff1eb27.jpg";